import { useMemo } from 'react'

import { usePositions } from '@/features/positions'

/**
 * Hook for filtering positions by role and level
 * Provides utilities for cascading dropdowns: Role -> Level -> Position ID
 */
export const usePositionRoleLevels = () => {
  const { positions } = usePositions()

  // Get unique roles from positions
  const uniqueRoles = useMemo(() => {
    const roles = positions.map((p) => p.role)
    return Array.from(new Set(roles)).sort()
  }, [positions])

  // Get levels for a specific role
  const getLevelsForRole = (role: string) => {
    return positions
      .filter((p) => p.role === role)
      .map((p) => ({
        level: p.level,
        id: p.id,
        title: p.title,
      }))
      .sort((a, b) => a.level.localeCompare(b.level))
  }

  // Find position ID by role and level
  const findPositionId = (role: string, level: string): string | undefined => {
    const position = positions.find((p) => p.role === role && p.level === level)
    return position?.id
  }

  return {
    uniqueRoles,
    getLevelsForRole,
    findPositionId,
    positions,
  }
}
